module.exports = "/_next/static/images/e930dd219c28489349025c85143a1f12-holding-card-vertical@1x.png.webp";